import { useEffect, useState } from "react";
import { trpc } from "@/lib/trpc";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Label } from "@/components/ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { Textarea } from "@/components/ui/textarea";
import { XCircle } from "lucide-react";

export default function ConfirmLossDialog({
  open,
  onClose,
  onConfirm,
  dealTitle,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: (lossReasonId: number | null, note?: string) => void;
  dealTitle: string;
}) {
  const reasonsQuery = trpc.crm.lossReasons.list.useQuery({}, { enabled: open });
  const [picked, setPicked] = useState<string>("none");
  const [note, setNote] = useState("");

  useEffect(() => {
    if (open) {
      setPicked("none");
      setNote("");
    }
  }, [open]);

  return (
    <AlertDialog open={open} onOpenChange={(v) => !v && onClose()}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <div className="flex items-center gap-3">
            <div className="h-10 w-10 rounded-lg bg-red-100 dark:bg-red-950 text-red-600 dark:text-red-400 flex items-center justify-center">
              <XCircle className="h-5 w-5" />
            </div>
            <div>
              <AlertDialogTitle>Marcar como perdida?</AlertDialogTitle>
              <AlertDialogDescription>
                {dealTitle
                  ? `"${dealTitle}" será registrada como perdida.`
                  : "Esta oportunidade será marcada como perdida."}
              </AlertDialogDescription>
            </div>
          </div>
        </AlertDialogHeader>

        <div className="space-y-3 pt-2">
          <div>
            <Label className="text-xs">Motivo da perda</Label>
            <Select value={picked} onValueChange={setPicked}>
              <SelectTrigger className="mt-1">
                <SelectValue placeholder="Selecione um motivo (opcional)" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Sem motivo específico</SelectItem>
                {(reasonsQuery.data ?? []).map((r: any) => (
                  <SelectItem key={r.id} value={String(r.id)}>
                    {r.name}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="text-xs">Observação (opcional)</Label>
            <Textarea
              value={note}
              onChange={(e) => setNote(e.target.value)}
              rows={2}
              placeholder="Ex: cliente escolheu concorrente por preço 15% menor..."
              className="mt-1"
            />
          </div>
        </div>

        <AlertDialogFooter>
          <AlertDialogCancel>Voltar</AlertDialogCancel>
          <AlertDialogAction
            onClick={() =>
              onConfirm(picked !== "none" ? Number(picked) : null, note.trim() || undefined)
            }
            className="bg-red-600 hover:bg-red-700 focus:ring-red-600"
          >
            Confirmar perda
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
